import React from 'react'
import Header from '../_components/common/Header'
import Index from '../_components/StudentReport/Index'


const StudentReports = () => {
  return (
    
    <div className='page-main'>
        <Header name =  {["Student Reports"]} />
        <Index />

    </div>
  )
}

export default StudentReports